import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class ZoomAnimation {
  constructor(element) {
    this.element = element;

    /**
     * Parent container holding cards
     */
    this.zoomCard = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        toggleActions: 'play pause resume reset',
        // scrub: 1,
        end: 'top 5%',
      },
    });
  }

  init() {
    // ScrollTrigger.defaults({
    //   toggleActions: 'restart pause resume pause',
    // });

    /**
     * Add card animations to master timeline
     */
    this.zoomCard.add(this.addZoomCard());
  }

  /**
   * The individual cards
   * @return {object} gsap timeline
   */
  addZoomCard() {
    const tl = gsap.timeline();
    const elementNodes = this.element.querySelectorAll('[data-element="zoom-scroll-element"]');
    const elements = gsap.utils.toArray(elementNodes);

    tl.from(elements, {
      duration: 1,
      ease: 'power3.inOut',
      scale: 0.9,
      // stagger: {
      //   each: 0.25,
      // },
    });

    return tl;
  }
}

const zoomAnimations = {
  init() {
    const animationContainer = document.querySelectorAll('[data-module="scroll-zoom-animation"]');

    if (animationContainer && animationContainer.length) {
      animationContainer.forEach((container) => {
        const animation = new ZoomAnimation(container);
        animation.init();
      });
    }
  },
};

export default zoomAnimations;
